import { ColumnType, type IndexDescription } from "src/db";
import type { SelectableField } from "../types";

const GROUPABLE_TYPES = new Set<ColumnType>([ColumnType.STRING, ColumnType.BOOLEAN]);

const toSelectable = (field: IndexDescription): SelectableField => ({
    value: field.name,
    label: field.header_name,
});

export const selectOverviewFields = (description: IndexDescription[]): SelectableField[] => {
    const flagged = description.filter((field) => field.facet === true);
    if (flagged.length > 0) return flagged.map(toSelectable);
    return description.filter((field) => GROUPABLE_TYPES.has(field.type)).map(toSelectable);
};
